import React, { useContext } from 'react';
import { ProgramContext, UserDataContext } from '../../../contexts/context';
import { Card, theme } from 'antd';
import '../../../assets/profile/profile.scss';
import ProfileData from './ProfileData';
import ProfileAvatar from './ProfileAvatar';
const { useToken } = theme;
const { Meta } = Card;


const Profile = () => {
  const { authorizedUser } = useContext(UserDataContext)
  const { token } = useToken();

  return (
    <div className='profile'>
      <div className='profile__container'>
        <Card
          bodyStyle={{
            padding:'0',
            backgroundColor: token.colorBgLayout,
          }}
          bordered={false}
          style={{boxShadow:'none'}}
        >
          <Meta
            avatar={ <ProfileAvatar />}
            title={`ID: ${authorizedUser.id}`}
            description={<ProfileData />}
          />
        </Card>
      </div>
    </div>
  );
};

export default Profile;
